class IActiveTreatmentSummary {
    getActiveTreatmentSummary(patient, currentConditionEntry) {
        return null;
    }
}

export default IActiveTreatmentSummary;